var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('v-delete-confirm-modal'),_c('v-mobile-sidebar'),_c('v-sidebar'),_c('main',{staticClass:"main"},[_c('router-view')],1),_c('v-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }